import {
  Button,
  Grid,
  Paper,
  TableContainer,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { updateProductMetalPurityDetailsAPI } from "../../../Store/Action/productPurityAction";
import Colors from "../../../theme/Colors";
import CustomButton from "../../../Components/CustomButton";

const UpdateProductPurity = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { productMetal } = location.state || {};

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Home" },
      { key: "2", href: "/userList", text: "Masters" },
      { key: "3", href: "/productPurity", text: "Product Purity" },
      { key: "4", href: "/purityModule/edit", text: "Update Product Purity" },
    ]);
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  if (!productMetal) {
    return <div>No product details available.</div>;
  }

  const onSubmit = async (data) => {
    const requestData = {
      product_metal_purity_id: productMetal?.product_metal_purity_id,
      product_metal_purity_value: data?.metalPurityValue
    };
    try {
      await dispatch(
        updateProductMetalPurityDetailsAPI(requestData, (isSuccess, response) => {
          if (isSuccess?.status === true) {
            toast.success(response?.data?.message);
            navigate("/productPurity");
          } else {
            const errorMessage =
              response?.error?.message;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar />

          <div style={pageTitle}>
            <h2>Product Purity</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer component={Paper} style={tableContainer}>
          <p style={mainHeadingStyle}>Update Product Purity</p>

          <hr />

          <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Metal Purity Value</Typography>
                <Controller
                  name="metalPurityValue"
                  control={control}
                  defaultValue={productMetal.product_metal_purity_value}
                  rules={{ required: Strings.productValueRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Metal Purity Value"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.metalPurityValue}
                      helperText={
                        errors?.metalPurityValue ? errors?.metalPurityValue.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle, // Set background color
                      }}
                    />
                  )}
                />
              </Grid>

              <CustomButton handleSubmit={handleSubmit} label={Strings.Save} />
            </Grid>
          </form>
        </TableContainer>
      </div>
    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: "#F0F5FF",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const pageTitle = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const tableContainer = {
  width: "70vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
};

const formStyle = {
  padding: "20px",
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginTop: '20px',
  marginBottom: '20px'
};

const labelInfoStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginBottom: "5px",
};

const inputTextStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  backgroundColor: Colors.lightBlue,
};

const btnStyle = {
  height: "40px",
  width: "12vh",
  borderRadius: "8px",
  border: "1px solid #4A505C",
  fontSize: 14,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  marginTop: "10px",
};

export default UpdateProductPurity;
